<template>
  <div id="checkResults" class="section">
    <h1 class="title">Check your results</h1>
    <div class="control">
      <input
        class="input"
        type="text"
        placeholder="Enter your result Id"
        v-model="sessionCode"
      />
      <p class="is-danger help">{{ error.sessionCode }}</p>
    </div>
    <br />
    <div class="field">
      <label class="label">Language</label>
      <div class="control">
        <div class="select">
          <select v-model="languageId">
            <option disabled value="0">-- Select --</option>
            <option
              v-for="language in languages"
              :value="language.id"
              :key="language.id"
            >
              {{ language.name }}
            </option>
          </select>
          <p class="is-danger help">{{ error.language }}</p>
        </div>
      </div>
    </div>
    <br />
    <p class="control">
      <button
        class="button is-info"
        :class="{ 'is-loading': isLoading }"
        @click="getSession"
        v-if="canGetResult"
      >
        Get Result
      </button>
    </p>
    <br />
    <div v-if="isTestResultVisible">
      <Results />
    </div>
    <br />
  </div>
</template>

<script>
import Results from './Results';

export default {
  name: 'checkResults',
  components: {
    Results,
  },
  data() {
    return {
      sessionCode: '',
      isTestResultVisible: false,
      isLoading: false,
      languageId: 0,
      error: {
        sessionCode: this.msgSessionCode,
        language: this.msgLanguage,
      },
      testResults: undefined,
      canGetResult: true,
      languages: [
        { id: 2, name: 'English' },
        { id: 3, name: 'Tamil' },
        { id: 6, name: 'Hindi' },
      ],
    };
  },
  methods: {
    isSessionCodeValid() {
      if (this.$helpers.isOrgCode(this.sessionCode)) {
        this.error.sessionCode = '';
        return true;
      }
      this.error.sessionCode = this.msgSessionCode;
      return false;
    },
    isLanguageValid() {
      if (this.languageId !== 0) {
        this.error.language = '';
        return true;
      }
      this.error.language = this.msgLanguage;
      return false;
    },
    getSession() {
      if (!this.isSessionCodeValid()) {
        return;
      }
      if (!this.isLanguageValid()) {
        return;
      }
      this.isLoading = true;
      this.$http
        .post('/scarf/getSession', {
          sessionCode: this.sessionCode,
          params: { testId: this.languageId },
        })
        .then((res) => {
          this.isLoading = false;
          if (res.data.ok === 1) {
            console.log(res.data.status.isDemoDone);
            this.$temp.sessionCode = this.sessionCode;
            this.$temp.testId = this.languageId;
            if (res.data.status.isDemoDone && res.data.status.isTestsDone) {
              this.isTestResultVisible = true;
              this.canGetResult = false;
              return;
            }
            if (res.data.status.isDemoDone === false) {
              this.$toast.open('Please attend the demographic questions.');
              this.$router.push('language-selection');
            } else if (res.data.status.isTestsDone === false) {
              this.$toast.open('Please take the test.');
              if (this.languageId === 2) {
                this.$router.push('/tests/English');
              } else if (this.languageId === 3) {
                this.$router.push('/tests/Tamil');
              } else if (this.languageId === 4) {
                this.$router.push('/tests/Hindi');
              } else if (this.languageId === 5) {
                this.$router.push('/tests/Marathi');
              }
            }
          } else {
            this.$toast.open(res.data.msg);
          }
        });
    },
  },
  watch: {
    sessionCode(val) {
      if (this.$helpers.isOrgCode(val)) {
        this.error.sessionCode = '';
        return;
      }
      this.error.sessionCode = this.msgSessionCode;
    },
    language() {
      if (this.LanguageName !== '') {
        this.error.Language = '';
        return;
      }
      this.error.language = this.msgLanguage;
    },
  },
  computed: {
    msgSessionCode() {
      return 'Enter valid Result Id/Session Code';
    },
    msgLanguage() {
      return 'Select a Language';
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/CheckResults.vue